import { render, staticRenderFns } from "./OngkirCreateOrder.vue?vue&type=template&id=e177f0d0&scoped=true&"
import script from "./OngkirCreateOrder.vue?vue&type=script&lang=js&"
export * from "./OngkirCreateOrder.vue?vue&type=script&lang=js&"
import style0 from "./OngkirCreateOrder.vue?vue&type=style&index=0&id=e177f0d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e177f0d0",
  null
  
)

export default component.exports